export const ACCOUNT_TABS = ['account', 'company', 'plan'] as const;
export type AccountTab = (typeof ACCOUNT_TABS)[number];

export type AccountSearch = { tab?: AccountTab };

/**
 * @desc `validateSearch` for `/account`. The default tab ('account') is omitted from the URL, and
 * anything unrecognised falls back to it rather than erroring, so a stale link still lands.
 */
export const parseAccountSearch = (raw: Record<string, unknown>): AccountSearch => {
  const tab = ACCOUNT_TABS.find((candidate) => candidate === raw.tab);
  return tab && tab !== 'account' ? { tab } : {};
};
